import PhoneNumbers              from 'scripts/defa/phone-numbers/collection-phone-numbers';
import PhoneNumber               from 'scripts/defa/phone-numbers/model-phone-number';
import PhoneNumberCollectionView from 'scripts/defa/phone-numbers/view-phone-number-collection-view';
import PhoneNumberContainer      from 'scripts/defa/phone-numbers/view-phone-number-container';
import PhoneNumberCreateForm     from 'scripts/defa/phone-numbers/view-phone-number-create-form';
import PhoneNumberDeleteForm     from 'scripts/defa/phone-numbers/view-phone-number-delete-form';
import PhoneNumberSnippet        from 'scripts/defa/phone-numbers/view-phone-number-snippet';
import PhoneNumberUpdateForm     from 'scripts/defa/phone-numbers/view-phone-number-update-form';
import Module                    from 'scripts/module';

const PhoneNumberModule = new Module('PhoneNumberModule',{
	views: {
		PhoneNumberUpdateForm,
		PhoneNumberSnippet,
		PhoneNumberDeleteForm,
		PhoneNumberCreateForm,
		PhoneNumberContainer,
		PhoneNumberCollectionView
	},
	models: {
		PhoneNumber
	},
	collections: {
		PhoneNumbers
	}
});

export default PhoneNumberModule